import { render, staticRenderFns } from "./BCheckboxesWithValidation.vue?vue&type=template&id=715dd80e&"
import script from "./BCheckboxesWithValidation.vue?vue&type=script&lang=js&"
export * from "./BCheckboxesWithValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports